/**
 * Brand mark from assets/solfo_music_app_logo.svg — a sun with twelve
 * radiating rays around a quarter note. Recreated as a component so it can
 * render at any size/color (terracotta on light, cream on terracotta,
 * salmon on dark ink).
 */

const RAY_LENGTHS = [48, 47, 46, 48, 46, 47, 48, 46, 47, 48, 46, 47];

export const BRAND = {
  terracotta: '#D85A30',
  cream: '#FAECE7',
  salmon: '#F0997B',
  ink: '#2C2C2A',
} as const;

export function SolfoMark({
  size = 28,
  color = BRAND.terracotta,
  className,
}: {
  size?: number;
  color?: string;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-56 -56 112 112"
      className={className}
      role="img"
      aria-label="Solfo"
    >
      <g stroke={color} strokeWidth="4" strokeLinecap="round">
        {RAY_LENGTHS.map((len, i) => (
          <line key={i} x1="0" y1="-40" x2="0" y2={-len} transform={`rotate(${i * 30})`} />
        ))}
      </g>
      <circle cx="0" cy="0" r="31" fill="none" stroke={color} strokeWidth="6" />
      <circle cx="-7" cy="7" r="13" fill={color} />
      <line x1="6" y1="7" x2="6" y2="-21" stroke={color} strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export function SolfoLogo({
  size = 26,
  markColor = BRAND.terracotta,
  textClassName = 'text-slate-900',
}: {
  size?: number;
  markColor?: string;
  textClassName?: string;
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <SolfoMark size={size} color={markColor} />
      <span
        className={`font-medium tracking-tight ${textClassName}`}
        style={{ fontSize: size * 0.85, lineHeight: 1 }}
      >
        solfo
      </span>
    </span>
  );
}

/** App-icon tile (terracotta rounded square, cream mark) for splash/empty states. */
export function SolfoTile({ size = 56 }: { size?: number }) {
  return (
    <span
      className="inline-flex items-center justify-center"
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.22,
        background: BRAND.terracotta,
      }}
    >
      <SolfoMark size={size * 0.62} color={BRAND.cream} />
    </span>
  );
}
